module.exports = __webpack_public_path__ + "img/HZ-S4023.6d6da6e4.jpg";